import React from 'react'
import { Switch, Route, Redirect } from 'react-router'
import App from './routes/app'
import Dashboard from './routes/dashboard'
import Auth from './routes/auth'
import Callback from './routes/callback'
import Forgot from './routes/auth/components/Forgot'
import { getCurrentUser } from './routes/auth/components/util'

function handleAuthentication(props){
    return getCurrentUser() ? 
    <Dashboard {...props} /> : 
    <Auth {...props} />
}

const routes = () => (
  <App>
    <Switch>
      <Redirect exact from='/' to='/login' />
      <Route path='/login' component={Auth} />
      <Route path='/forgot-password' component={Forgot} />
      <Route path="/callback" component={Callback} />
      <Route path='/dashboard' component={(props) => handleAuthentication(props)} />
    </Switch>
  </App>
)

export default routes
